<template>
  <div class="pay-rules">
    <div @click="init" v-if="html" v-html="html"></div>
    <div v-if="html==undefined" class="money-detail-none">
      <img src="https://web-data.zmlearn.com/image/kED1eTLQU5Z2mBDFeRKgU7/no_arrange.png" />
      <div>暂无注意事项说明 请稍后查看</div>
    </div>
  </div>
</template>

<script>
import { querySalaryConfigDescription } from '../../api/pay';

export default {
  data() {
    return {
      html: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!this.$route.query.salaryConfigId) return this.html = undefined;
      const params = {
        salaryConfigId: this.$route.query.salaryConfigId,
      };
      querySalaryConfigDescription(params).then(res => {
        if (res) {
          this.html = res;
        } else {
          this.html = undefined;
        }
      }).catch(err => {
        this.html = undefined;
      });
    },
  },
};
</script>

<style lang="scss">
.pay-rules {
  padding: 0 30px 30px 30px;
  font-size: 26px;
  line-height: 55px;
  .money-detail-none {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-100%);
    font-size: 24px;
    div {
      padding-top: 20px;
    }
  }
  table {
    text-align: center;
    vertical-align: middle;
    border-collapse: collapse;
    position: relative;
    width: 100%;
    font-size: 20px;
    margin: 15px 0;
    line-height: 30px;
  }
  table thead {
    height: 35px;
  }
  table td {
    border: 0;
    padding: 15px;
    position: relative;
  }
  table td::after {
    content: '';
    display: block;
    position: absolute;
    left: 0%;
    top: 0%;
    width: 200%;
    height: 200%;
    border: 1px solid #000;
    border-top: none;
    border-right: none;
    transform-origin: 0 0;
    transform: scale(0.5);
  }
  table::after {
    content: '';
    display: block;
    position: absolute;
    left: 0%;
    top: 0%;
    width: 200%;
    height: 200%;
    border: 1px solid #000;
    border-left: none;
    border-bottom: none;
    transform-origin: 0 0;
    transform: scale(0.5);
  }
}
</style>